import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearSession } from '@/redux/slices/sessionStateSlice';

export type ColorMode = 'light' | 'dark' | 'system';

interface ColorModeState {
  mode: ColorMode;
}

const initialState: ColorModeState = {
  mode: 'system',
};

const colorModeSlice = createSlice({
  name: 'colorMode',
  initialState,
  reducers: {
    setColorMode(state, action: PayloadAction<ColorMode>) {
      state.mode = action.payload;
    },
  },
  // Color mode is a per-USER preference but the slice is persisted to localStorage, so on logout
  // (manual or session-expiry) reset it to 'system'. Otherwise the next user to sign in on this
  // browser inherits the previous user's mode until their own profile loads (and, if they have no
  // saved preference, forever). ThemeSyncLoader then applies the signed-in user's actual choice.
  extraReducers: (builder) => {
    builder.addCase(clearSession, (state) => {
      state.mode = 'system';
    });
  },
});

export const { setColorMode } = colorModeSlice.actions;
export default colorModeSlice.reducer;
